import { PURGE } from "redux-persist";

var initialState = {
  allCampaign: null,
  accountDetails: {},
  accountWallet: [],
  accountTrades: [],
  accountHistory: [],
  allInboxes: [],
  allMails: [],
  campaignLogs: null,
  isLoading: false,
  singleTask: null, 
  allAccounts: null,
  allAppAccounts:null,
  sendReply:null,
}

const Task = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE: return initialState;

    case 'SET_ALL_CAMPAIGNS':
      return {
        ...state,
        allCampaign: payload,
      };
      
      case 'SET_ALL_INBOXES':
        return {
          ...state,
          allInboxes: payload,
        };

        case 'SET_ALL_MAILS':
          return {
            ...state,
            allMails: payload,
          };


    case 'UPDATE_CAMPAIGN_STATE':
      const updatedIndex = state.allCampaign.findIndex(el => el._id === payload._id);

      if (updatedIndex !== -1) {
        const updatedCampaign = [...state.allCampaign];
        updatedCampaign[updatedIndex] = payload;

        return {
          ...state,
          allCampaign: updatedCampaign
        };
      }

      return state;

    case 'ADD_CAMPAIGN':
      return {
        ...state,
        allCampaign: [payload, ...state.allCampaign],
      };
    case 'ADD_REGISTER_ACCOUNT':
        return {
          ...state,
          allAccounts: [payload, ...state.allAccounts],
        };
    case 'ADD_REGISTER_APP_ACCOUNT':
          return {
            ...state,
            allAppAccounts: [payload, ...state.allAppAccounts],
          };SEND_REPLY
    case 'SEND_REPLY':
            return {
              ...state,
              sendReply: [payload, ...state.sendReply],
            };
    case 'SET_CAMPAIGN_LOGS':
      return {
        ...state,
        campaignLogs: payload
      };

    case 'SET_SINGLE_CAMPAIGN':
      return {
        ...state
      };
      case 'SET_SINGLE_TASK':
        return {
          ...state,
          singleTask: payload, 
        };
      case 'SET_EMAIL_SCHEDULE':
         return {
            ...state,
            allCampaign: payload,
         };
    
    default:
      return state;
  }
};

export default Task;
